import { render, staticRenderFns } from "./部門Select.vue?vue&type=template&id=316bc6e6&"
import script from "./部門Select.ts?vue&type=script&lang=ts&"
export * from "./部門Select.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports